export const WALK_STEPS = Object.freeze([.30,.49,.68,.87]);

const gaussian=(x,width)=>Math.exp(-Math.pow(x/width,2));

export function walkCameraMotion(progress){
  const p=Math.max(0,Math.min(1,Number(progress)||0));
  let y=0,x=0,roll=0,impact=0;
  WALK_STEPS.forEach((step,index)=>{
    const hit=gaussian(p-step,.058);
    const rebound=gaussian(p-(step+.055),.072);
    const side=index%2===0?1:-1;
    impact=Math.max(impact,hit);
    y+=(-.046*hit)+(.017*rebound);
    x+=side*.017*hit;
    roll+=side*.0018*hit;
  });
  const settle=p<=.92?1:p>=1?0:Math.pow((1-p)/.08,2);
  return {y:y*settle,x:x*settle,roll:roll*settle,impact:impact*settle};
}

let audio=null;

function buildImpulse(ctx){
  const duration=1.05,length=Math.floor(ctx.sampleRate*duration);
  const buffer=ctx.createBuffer(2,length,ctx.sampleRate);
  for(let channel=0;channel<2;channel++){
    const data=buffer.getChannelData(channel);
    for(let i=0;i<length;i++){
      const t=i/ctx.sampleRate;
      const early=(t>.075&&t<.095?1.8:0)+(t>.18&&t<.205?1.05:0)+(t>.31&&t<.34?.55:0);
      const tail=Math.exp(-t*4.7);
      data[i]=(Math.random()*2-1)*tail*(.17+early);
    }
  }
  return buffer;
}

function ensureAudio(){
  if(typeof window==='undefined')return null;
  const AudioCtor=window.AudioContext||window.webkitAudioContext;
  if(!AudioCtor)return null;
  if(audio)return audio;
  const ctx=new AudioCtor();
  const master=ctx.createGain();master.gain.value=.50;master.connect(ctx.destination);
  const convolver=ctx.createConvolver();convolver.buffer=buildImpulse(ctx);
  const reverbTone=ctx.createBiquadFilter();reverbTone.type='lowpass';reverbTone.frequency.value=2350;reverbTone.Q.value=.35;
  const wet=ctx.createGain();wet.gain.value=.17;
  convolver.connect(reverbTone);reverbTone.connect(wet);wet.connect(master);
  audio={ctx,master,convolver};
  return audio;
}

export function unlockWalkAudio(){
  const system=ensureAudio();
  if(!system)return Promise.resolve(false);
  const activate=()=>{
    try{
      const source=system.ctx.createBufferSource();
      const buffer=system.ctx.createBuffer(1,1,system.ctx.sampleRate);
      const gain=system.ctx.createGain();gain.gain.value=.00001;
      source.buffer=buffer;source.connect(gain);gain.connect(system.master);source.start();
      return true;
    }catch{return false;}
  };
  if(system.ctx.state==='running')return Promise.resolve(activate());
  return system.ctx.resume().then(()=>activate(),()=>false);
}

function makeContact(ctx,duration=.046){
  const length=Math.max(1,Math.floor(ctx.sampleRate*duration));
  const buffer=ctx.createBuffer(1,length,ctx.sampleRate);
  const data=buffer.getChannelData(0);
  for(let i=0;i<length;i++){
    const t=i/length;
    data[i]=(Math.random()*2-1)*Math.pow(1-t,4.2);
  }
  return buffer;
}

function resonantTap(system,time,index){
  const {ctx,master,convolver}=system;
  const near=index/(WALK_STEPS.length-1);
  const panValue=(index%2===0?-.075:.075);
  const dry=.030+near*.018;
  const sendLevel=.115-near*.035;

  const contact=ctx.createBufferSource();contact.buffer=makeContact(ctx);
  const body=ctx.createBiquadFilter();body.type='bandpass';body.frequency.value=760+near*110+(index%2?28:-24);body.Q.value=5.8;
  const sheen=ctx.createBiquadFilter();sheen.type='bandpass';sheen.frequency.value=1530+near*120+(index%2?38:-30);sheen.Q.value=7.5;
  const bodyGain=ctx.createGain(),sheenGain=ctx.createGain();
  bodyGain.gain.setValueAtTime(.0001,time);bodyGain.gain.exponentialRampToValueAtTime(dry,time+.006);bodyGain.gain.exponentialRampToValueAtTime(.0001,time+.072);
  sheenGain.gain.setValueAtTime(.0001,time);sheenGain.gain.exponentialRampToValueAtTime(dry*.48,time+.004);sheenGain.gain.exponentialRampToValueAtTime(.0001,time+.038);

  const panner=ctx.createStereoPanner?ctx.createStereoPanner():null;
  if(panner)panner.pan.value=panValue;
  contact.connect(body);contact.connect(sheen);body.connect(bodyGain);sheen.connect(sheenGain);
  const dryBus=ctx.createGain();dryBus.gain.value=1;
  bodyGain.connect(dryBus);sheenGain.connect(dryBus);
  if(panner){dryBus.connect(panner);panner.connect(master);}else dryBus.connect(master);

  const send=ctx.createGain();send.gain.value=sendLevel;
  if(panner)panner.connect(send);else dryBus.connect(send);
  send.connect(convolver);
  contact.start(time);contact.stop(time+.08);

  const heel=ctx.createOscillator();heel.type='sine';
  heel.frequency.setValueAtTime(176+near*10,time);heel.frequency.exponentialRampToValueAtTime(118,time+.09);
  const heelGain=ctx.createGain();
  heelGain.gain.setValueAtTime(.0001,time);heelGain.gain.exponentialRampToValueAtTime(.012+near*.006,time+.008);heelGain.gain.exponentialRampToValueAtTime(.0001,time+.105);
  heel.connect(heelGain);heelGain.connect(master);heel.start(time);heel.stop(time+.115);
}

export function playWalkSequence(durationMs){
  const system=ensureAudio();
  if(!system||!(durationMs>300))return;
  const schedule=()=>{
    const base=system.ctx.currentTime+.018;
    WALK_STEPS.forEach((step,index)=>resonantTap(system,base+(durationMs/1000)*step,index));
  };
  if(system.ctx.state==='running')schedule();
  else unlockWalkAudio().then(ok=>{if(ok)schedule();}).catch(()=>{});
}
